import SuperRepository from '../superRepository'

export default new class SalesScriptRepository extends SuperRepository {
  baseUri () {
    return 'sales-script'
  }
  getByOffer = async (id, params = {}) => this.httpClient().get(`${this.baseUri()}/by-offer/${id}`,params);
}
